// extracted by mini-css-extract-plugin
export default {"header":"TabSelector-module--header--be273","tab":"TabSelector-module--tab--31787","active":"TabSelector-module--active--d40b9"};